<template>
  <DatePicker
    ref="datepicker"
    v-model="localValue"
    locale="fr-CH"
    :mode="mode"
    :popover="popover"
    timezone="Europe/Berlin"
    class="relative-parent"
    is24hr
  >
    <template v-slot="{ inputValue, inputEvents, togglePopover }">
      <div class="datepicker">
        <input
          v-bind="$attrs"
          :value="inputValue"
          class="datepicker__field field"
          :placeholder="format.placeholder"
          readonly
          v-on="inputEvents"
        />

        <Btn variant="icon" class="datepicker__icon" @click="togglePopover">
          <Icon id="calendar" :scale="0.85" />
        </Btn>
        <Btn variant="icon" class="datepicker__icon" @click="cleanDate">
          <Icon id="cross" :scale="0.85" />
        </Btn>
      </div>
    </template>
  </DatePicker>
</template>

<script>
import { DatePicker } from 'v-calendar';
import { parseDate } from '@/helpers/dates';

export default {
  components: {
    DatePicker,
  },

  inheritAttrs: false,

  props: {
    mode: {
      type: String,
      default: 'date',
    },
    value: {
      type: [String, Date],
      default: null,
    },
  },

  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    masks() {
      return {
        L: 'DD.MM.YY',
      };
    },

    popover() {
      return {
        visibility: 'hidden',
      };
    },

    format() {
      const formats = {
        date: {
          mask: 'DD.MM.YYYY',
          placeholder: 'JJ.MM.AAAA',
        },
        dateTime: {
          mask: 'DD.MM.YYYY HH:mm',
          placeholder: 'JJ.MM.AAAA 00:00',
        },
        time: {
          mask: 'HH:mm',
          placeholder: '00:00',
        },
      };

      return formats[this.mode];
    },
  },

  methods: {
    cleanDate() {
      this.$emit('input', null);
    },
  },
};
</script>

<style lang="scss">
// Prevent the Kanbasu grid from taking over `v-calendar` classes.
.vc-pane-container {
  > .grid {
    margin-left: 0;
  }
}
</style>

<style lang="scss" scoped>
input[readonly] {
  background-color: white;
  cursor: default;
}

.datepicker {
  width: 240px;
  display: flex;
}

.datepicker__field.field {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.datepicker__icon {
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 0 auto;

  border: $field-border;
  border-left: 0;
  background-color: $alt-100;
}
</style>
